import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Stack from "@mui/material/Stack";

export default function CustomDatePicker({
  value,
  onChange,
  disablePast = false,
  disableFuture = true,
  minDate,
  maxDate,
  disabled = false,
  containerStyle,
  inputStyles,
  fieldHoverStyles,
  inputsStyles,
  placeholder = "Date",
}) {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Stack>
          <DatePicker
            disabled={disabled}
            // disableOpenPicker={disabled}
            minDate={minDate && minDate}
            maxDate={maxDate && maxDate}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            showTodayButton
            disablePast={disablePast}
            disableFuture={disableFuture}
            openTo="day"
            views={["year", "month", "day"]}
            value={value || null}
            onChange={(newValue) => {
              onChange(newValue);
            }}
            inputFormat="DD/MM/YYYY"
            renderInput={(params) => (
              <TextField
                autoComplete="off"
                disabled={disabled}
                sx={{
                  svg: { color: "#38369C" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#F3F3F3",
                      outline: "none",
                      ...inputStyles,
                    },
                    "&:hover fieldset": {
                      borderColor: "#F3F3F3",
                      outline: "none",
                      ...fieldHoverStyles,
                    },
                  },
                  "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
                    // padding: 1.3,
                    ...inputsStyles,
                  },
                }}
                {...params}
                style={{
                  backgroundColor: "#F3F3F3",
                  borderRadius: "5px",
                  height: "55px",
                  ...containerStyle,
                }}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                inputProps={{
                  ...params.inputProps,
                  placeholder: placeholder,
                }}
                onClick={(e) => !disabled && setOpen(true)}
              />
            )}
          />
        </Stack>
      </LocalizationProvider>
    </div>
  );
}
